import { Path } from 'react-native-svg';
import React from 'react';

import { IconDef, IconSpecificStyles } from './types';

export const ArrowDown: IconDef = {
  svg: (
    <Path
      d="M5 7.5L10 12.5L15 7.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
